import { Component, } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { Designbox } from './../../models/designboxes/designboxes.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-designboxes-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html' // TODO: tile list template
})
export class DesignboxesListComponent extends ListBase<Designbox> {

  public url = 'designboxes';
  public routePrefix = 'designboxes';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
